import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import useCheckout from '../../../../../hooks/adyen/useCheckout.js';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '../../../../../models/adyen/payment-type.js';
import '@grandvisionhq/icons';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import { GooglePayContainer } from '../../../containers/Adyen/GooglePay/GooglePayContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';

const getGPayConfig = (locale)=>({
        // Step 2: Set the callback intents.
        callbackIntents: [
            'SHIPPING_ADDRESS'
        ],
        // Step 3: Set shipping configurations.
        shippingAddressRequired: false,
        shippingAddressParameters: {
            allowedCountryCodes: [],
            phoneNumberRequired: true
        },
        // Shipping method option configurations.
        shippingOptionRequired: false,
        isExpress: false,
        // Line items.
        transactionInfo: {
            displayItems: [
                {
                    label: 'Subtotal',
                    type: 'SUBTOTAL',
                    price: '99.00'
                },
                {
                    label: 'Tax',
                    type: 'TAX',
                    price: '1.00'
                }, 
            ],
            countryCode: 'US',
            currencyCode: 'USD',
            totalPriceStatus: 'FINAL',
            totalPrice: '100.00',
            totalPriceLabel: 'Total'
        },
        // Step 6: Update the payment data.
        paymentDataCallbacks: {
            onPaymentDataChanged (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { callbackTrigger , shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    // Validate the country/region and address selection.
                    if (shippingAddress && shippingAddress.countryCode !== locale) {
                        paymentDataRequestUpdate.error = {
                            reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                            message: 'Cannot ship to the selected address',
                            intent: 'SHIPPING_ADDRESS'
                        };
                    }
                    resolve(paymentDataRequestUpdate);
                });
            }
        },
        // Step 7: Configure the callback to get the shopper's information.
        onAuthorized: (paymentData)=>{
            console.log('Shopper details', paymentData);
        }
    })
;
const GooglePay = ()=>{
    const { locale  } = useIntl();
    const onChange = ()=>{
        alert('gpay update');
    };
    const googlePayConfig = getGPayConfig(locale);
    const checkout = useCheckout(onChange);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.googlepay.info"
    }), /*#__PURE__*/ React.createElement(GooglePayContainer, {
        checkout: checkout,
        googlePaymentConfig: googlePayConfig
    }));
};

export { GooglePay };
//# sourceMappingURL=GooglePay.js.map
